'use client';
import { Button } from '@/components/ui/button';

export function ModifyCard({ product, onSelect, isCartBlocked = false }) {
  // Remove cart dependency since we're modifying an order, not creating a new one
  const handleAddToOrder = (e) => {
    e.stopPropagation();
    onSelect(product, 1);
  };

  const discount = (((product.mrp - product.netPrice) / product.mrp) * 100).toFixed(0);

  if (!product.available) {
    return null;
  }

  return (
    <div
      className={`bg-white rounded-lg overflow-hidden border relative ${
        product?.available ? 'cursor-pointer' : 'opacity-65 cursor-not-allowed'
      }`}
      onClick={() => {
        if (product?.available && product.productVariants.length > 1) {
          onSelect(product);
        }
      }}
    >
      {!product?.available && (
        <h2 className="absolute text-black font-bold z-50 top-1/2 text-center w-full -translate-y-1/2 text-balance text-base">
          Not Available
        </h2>
      )}
      <div className="relative">
        <img
          loading="lazy"
          src={product.productImageUrl || '/placeholder.svg'}
          alt={product.productName}
          className="w-full h-32 object-cover"
        />
        <div className="absolute -bottom-3 right-2">
          <Button
            variant="secondary"
            size="sm"
            className="border border-[#39c55e]"
            onClick={handleAddToOrder}
            disabled={!product?.available || isCartBlocked}
          >
            Add
          </Button>
        </div>
      </div>
      <div className="p-3 space-y-2">
        <h3 className="font-medium text-sm">{product.productName}</h3>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1">
            <span className="text-sm font-bold">₹{product?.productVariants[0]?.netPrice}</span>
            {product.mrp !== product.netPrice && (
              <span className="text-xs text-gray-500 line-through">
                ₹{product?.productVariants[0].mrp}
              </span>
            )}
          </div>
          <div className="text-sm border rounded-md px-2 py-1">
            {product?.productVariants[0].variant || 1} {product?.productVariants[0].unit}
          </div>
        </div>
      </div>
    </div>
  );
}
